import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link, useNavigate } from 'react-router-dom';
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import Breadcrumbs from '../components/Breadcrumbs';
import Header_1 from '../headers/Header_1';
import { Turnstile } from "@marsidev/react-turnstile";
import SEO from '../components/Seo';

export const Reparaturmeldung = () => {
    const navigate = useNavigate();

    useEffect(() => {
        $(".select2").select2();
    }, []);

    const fileRef = useRef(null);
    const [fileName, setFileName] = useState("");


    const [isLoading, setIsLoading] = useState(false);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/reparaturmeldung-form?populate[Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*&populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Metadaten]=*");



            const data = await response.json();
            console.log('test', data?.data?.Modul);

            if (data.data) {
                setMetaData(data?.data?.Metadaten);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])


    const handleClick = () => {
        fileRef.current.click();
    };

    // const handleChange = (e) => {
    //     if (e.target.files.length > 0) {
    //         setFileName(e.target.files[0].name);
    //     }
    // };

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".dokumente_slider .item_inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            // 👉 P elements
            const paragraphs = document.querySelectorAll(
                ".dokumente_slider .item_inner p"
            );

            let maxP = 0;
            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });
            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 800);

        // run on resize
        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    // ================= STATES =================

    const [formData, setFormData] = useState({
        anrede: "",
        vorname: "",
        nachname: "",
        strasse: "",
        ort: "",
        plz: "",
        telefon: "",
        email: "",
        category: "",
        damageDescription: "",
        // message: "",
    });

    const [errors, setErrors] = useState({});

    // ================= HANDLE FORM =================

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let newValue = value;

        // Allow only numbers, spaces and +
        if (name === "telefon") {
            newValue = value.replace(/[^0-9+\s]/g, "");
        }

        setFormData((prev) => ({
            ...prev,
            [name]: newValue,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setFileName(file.name);
        }
    };


    // ================= SELECT2 =================

    useEffect(() => {
        $(".select2").each(function () {
            const $this = $(this);

            $this.select2();

            $this.on("change", function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                console.log("Changed:", name, value);

                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");

                if (name in formData) {
                    setFormData((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }
            });
        });

        return () => {
            const selects = $(".select2");
            selects.each(function () {
                const $el = $(this);

                // destroy only if initialized
                if ($el.data("select2")) {
                    console.log("Destroying select2 for", $el.attr("name"));
                    $el.select2("destroy");
                }
            });
        };
    }, []);

    useEffect(() => {
        $(".select2").each(function () {
            const name = $(this).attr("name");

            console.log("Validating select:", name, formData[name], errors[name]);

            if (errors[name] && formData[name].trim() === "") {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .addClass("warning-border shake");
            } else {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");
            }
        });
    }, [errors]);


    // ================= SUBMIT =================
    const [captchaToken, setCaptchaToken] = useState("");
    const [captchaError, setCaptchaError] = useState(false);

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const validateForm = () => {
        let newErrors = {};

        const requiredFields = [
            "anrede",
            "vorname",
            "nachname",
            "strasse",
            "ort",
            "plz",
            "telefon",
            "email",
            "category",
            "damageDescription",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                newErrors[field] = true;
            }
        });

        if (formData.email && !isValidEmail(formData.email)) {
            newErrors.email = true;
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("Submitting form with data:", formData);

        const isValid = validateForm();

        if (!isValid) {
            return;
        }

        if (!captchaToken) {
            setCaptchaError(true);
            return;
        }

        try {
            setIsSubmitting(true);

            const submitData = new FormData();

            // append text fields
            Object.keys(formData).forEach((key) => {
                submitData.append(key, formData[key]);
            });

            // append file
            if (fileRef.current.files[0]) {
                submitData.append("file", fileRef.current.files[0]);
            }

            const response = await fetch(
                `${process.env.REACT_APP_FRONTEND_URL}api/submit-formulare-form?pageTitle=Reparaturmeldung`,
                {
                    method: "POST",
                    body: submitData,
                }
            );

            const data = await response.json();

            console.log(data);

            if (data?.success) {

                // RESET
                setFormData({
                    anrede: "",
                    vorname: "",
                    nachname: "",
                    strasse: "",
                    ort: "",
                    plz: "",
                    telefon: "",
                    email: "",
                    category: "",
                    damageDescription: "",
                    // message: "",
                });

                setFileName("");

                navigate("/vielen-dank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}            

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-1-titel-text" && (
                            <Header_1 title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage='Wohnen' activeInnerPage={'Mieterservice'} />
                        )}
                    </React.Fragment>
                ))
            )}

            {/* <Header_1 title={'Reparaturmeldung'} description={'Reparaturmeldungen richten Sie bitte mit dem untenstehenden Formular direkt an die Werkstätten der BGZ. Der zuständige Hauswart wird sich schnellstmöglich bei Ihnen melden.'} sectionClass="banners-wohnen" activePage='Wohnen' activeInnerPage={'Mieterservice'} staticDescription={true} /> */}

            <section className={`pt-pb-10 sec-orange-color sec-bg-grey`}>
                <div className='container'>
                    <form className="form-container" onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-sm-6 form-group'>
                                {/* <input type="text" className="form-control" placeholder="Anrede *" name="Anrede *" /> */}
                                <select
                                    className="form-control select2"
                                    name="anrede"
                                    value={formData.anrede}
                                >
                                    <option value="" disabled>
                                        Anrede *
                                    </option>

                                    <option value="Frau">Frau</option>
                                    <option value="Herr">Herr</option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.vorname ? "warning-border shake" : ""}`}
                                    placeholder="Vorname*"
                                    name="vorname"
                                    value={formData.vorname}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.nachname ? "warning-border shake" : ""}`}
                                    placeholder="Nachname *"
                                    name="nachname"
                                    value={formData.nachname}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.strasse ? "warning-border shake" : ""}`}
                                    placeholder="Strasse + Nr. *"
                                    name="strasse"
                                    value={formData.strasse}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.ort ? "warning-border shake" : ""}`}
                                    placeholder="Ort *"
                                    name="ort"
                                    value={formData.ort}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.plz ? "warning-border shake" : ""}`}
                                    placeholder="PLZ *"
                                    name="plz"
                                    value={formData.plz}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.telefon ? "warning-border shake" : ""}`}
                                    placeholder="Telefon *"
                                    name="telefon"
                                    value={formData.telefon}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <input
                                    type="email"
                                    className={`form-control ${errors.email ? "warning-border shake" : ""}`}
                                    placeholder="E-Mail *"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-sm-6 form-group'>
                                <select
                                    className={`form-control select2`}
                                    name="category"
                                    value={formData.category}
                                    onChange={handleInputChange}
                                >
                                    <option value="" className='placeholder' disabled>
                                        Ort des Schadens *
                                    </option>

                                    <option value="Wasser und Sanitäranlagen (Bad, WC, Küche, Waschküche)">
                                        Wasser und Sanitäranlagen (Bad, WC, Küche, Waschküche)
                                    </option>

                                    <option value="Elektroanlagen (Steckdosen, Schalter etc.)">
                                        Elektroanlagen (Steckdosen, Schalter etc.)
                                    </option>

                                    <option value="Einbaugeräte Küche (Herd, Kühlschrank etc.)">
                                        Einbaugeräte Küche (Herd, Kühlschrank etc.)
                                    </option>

                                    <option value="Wohnung (Boden, Wände, Fenster etc.)">
                                        Wohnung (Boden, Wände, Fenster etc.)
                                    </option>

                                    <option value="Heizung (Heizkörper, Heizrohre etc.)">
                                        Heizung (Heizkörper, Heizrohre etc.)
                                    </option>

                                    <option value="Schliessungsänderung (Schlüssel verloren, Schlüssel gestohlen)">
                                        Schliessungsänderung (Schlüssel verloren, Schlüssel gestohlen)
                                    </option>

                                    <option value="Allgemeinräume (Treppenhaus, Waschküche etc.)">
                                        Allgemeinräume (Treppenhaus, Waschküche etc.)
                                    </option>

                                    <option value="Anderes">
                                        Anderes
                                    </option>
                                </select>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <div className="upload-wrapper" onClick={handleClick}>
                                    <span className={`upload-text ${fileName ? "active" : ""}`}>
                                        {fileName || "Foto hochladen"}
                                    </span>

                                    <span className="upload-icon">
                                        <img src='images/upload-icon.svg' alt="" />
                                    </span>

                                    <input
                                        type="file"
                                        ref={fileRef}
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                    />
                                </div>
                            </div>
                            {/* <div className='col-sm-12 form-group'>
                                <input
                                    type="text"
                                    className={`form-control ${errors.damageDescription ? "warning-border shake" : ""}`}
                                    placeholder="Beschreibung des Schadens, Gerät (mit Angaben von Seriennummer, Fehlermeldung, Typ, Marke) *"
                                    name="damageDescription"
                                    value={formData.damageDescription}
                                    onChange={handleInputChange}
                                />
                            </div> */}
                            <div className='col-sm-12 form-group'>
                                <textarea
                                    rows={5}
                                    className="form-control"
                                    placeholder="Beschreibung des Schadens, Gerät (mit Angaben von Seriennummer, Fehlermeldung, Typ, Marke) *"
                                    name="damageDescription"
                                    value={formData.damageDescription}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>
                            <div className='col-sm-6 form-captcha'>
                                <div className='google_recaptcha'>
                                    <Turnstile
                                        siteKey="0x4AAAAAADt5N15MzxPtrdSe"
                                        onSuccess={(token) => {
                                            setCaptchaToken(token);
                                            setCaptchaError(false);
                                        }}
                                        onExpire={() => {
                                            setCaptchaToken("");
                                        }}
                                    />

                                    {captchaError && (
                                        <p
                                            style={{
                                                color: "red",
                                                marginTop: "10px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Bitte bestätigen Sie das Captcha.
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className='col-sm-6 form-btn mt-4 mt-sm-0'>
                                <button
                                    type='submit'
                                    className="button round_btn btn-theme-color"
                                    disabled={isSubmitting}
                                >
                                    {/* {isSubmitting ? "Sending..." : "senden"} */}
                                    senden

                                    <span>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                            <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    )
}